import { ActionContext } from 'vuex';
import {ListStateItem, ListModuleItem} from '@/store/shared/index'
import DeclareGroup from './entity'
import DeclareCustoms from "@/store/modules/shipment/declarecustoms/entity";
import {$http} from '@/lib'
import {PageResult} from '@/store/shared/entity';

//定义 interface  常用情况 edit页面entity  codelist等   页面需要的数据对象都要在此声明
interface DeclareGroupState extends ListStateItem<DeclareGroup>{
    editDeclareGroup: DeclareGroup;
    declareCustomsDetail: DeclareCustoms;
}

class DeclareGroupModule extends ListModuleItem<DeclareGroupState,any,DeclareGroup>{

    //构造函数 （必须）将派生类中 的overrideState 和 overrideMutations 与基类（ListModuleItem）中的state mutations合并
    constructor() {
        super();
        Object.assign(this.state, this.overrideState);
        Object.assign(this.mutations, this.overrideMutations);
    }
    
    //state  页面需要的数据对象都要在此实例化  
    overrideState = {
       editDeclareGroup: new DeclareGroup(),
       declareCustomsDetail: new DeclareCustoms(),
    }

    //action中 function 都是异步
    actions = {
        async getShipmentListDetail(context: ActionContext<DeclareGroupState, any>, payload: any) {
            let reponse = await $http.get('/services/app/DeclareGroup/GetShipmentListDetail', { params: payload });
            context.state.declareCustomsDetail = reponse.data.result as DeclareCustoms;
        },
        async saveShipmentList(context: ActionContext<DeclareGroupState, any>, payload: any) {
            await $http.post('/services/app/DeclareGroup/SaveShipmentList', payload.data);
        },
        async getShipmentList(context: ActionContext<DeclareGroupState, any>, payload: any) {
            let reponse = await $http.get('/services/app/DeclareGroup/GetShipmentList', { params: payload });
            return reponse.data.result as DeclareCustoms;
        },
        
    };

    overrideMutations = {
        edit(state: DeclareGroupState, declareGroup: DeclareGroup) {
            state.editDeclareGroup = declareGroup;
        }
    }
}

const declareGroupModule = new DeclareGroupModule();
export default declareGroupModule;


